import Vue from 'vue'
import PackageTransformer from '@/transformers/extranet/PackageByIdTransformer.js'

/**
 * @autor José Luis R. <jose.ruiz@jbge.com>
 */

const fetchSinisterPackageById = id =>
   Vue.$http.get(`extranet/package/detail/${id}/`)
    .then(response => PackageTransformer.fetch(response.data))
    .catch((err) => { throw err })


export default fetchSinisterPackageById


// WEBPACK FOOTER //
// ./src/services/extranet/fetchSinisterPackageById.js